import React, { useState } from 'react';
import { useCustomers } from '../hooks/useDatabase';

const CustomerPage = () => {
  const { customers, createCustomer, updateCustomer, deleteCustomer, loading, error } = useCustomers();

  const [showForm, setShowForm] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [formData, setFormData] = useState({
    customerName: '',
    phoneNumber: '',
    contactPerson: '',
    mainAddress: '',
    deliveryAddress: '',
    taxId: '',
    customerCode: ''
  });
  const [searchFilters, setSearchFilters] = useState({
    customerName: '',
    phoneNumber: '',
    contactPerson: '',
    customerCode: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    setEditingCustomer(null);
    setFormData({
      customerName: '',
      phoneNumber: '',
      contactPerson: '',
      mainAddress: '',
      deliveryAddress: '',
      taxId: '',
      customerCode: ''
    });
    setShowForm(true);
  };

  const handleEdit = (customer) => {
    setEditingCustomer(customer);
    setFormData({
      customerName: customer.customerName || '',
      phoneNumber: customer.phoneNumber || '',
      contactPerson: customer.contactPerson || '',
      mainAddress: customer.mainAddress || '',
      deliveryAddress: customer.deliveryAddress || '',
      taxId: customer.taxId || '',
      customerCode: customer.customerCode || ''
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('คุณต้องการลบข้อมูลลูกค้านี้หรือไม่?')) {
      const result = await deleteCustomer(id);
      if (result.success) {
        alert('ลบข้อมูลลูกค้าเรียบร้อยแล้ว');
      } else {
        alert('เกิดข้อผิดพลาดในการลบข้อมูล: ' + result.error);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (editingCustomer) {
      // แก้ไขข้อมูล
      const result = await updateCustomer(editingCustomer.id, formData);
      if (result.success) {
        alert('แก้ไขข้อมูลลูกค้าเรียบร้อยแล้ว');
      } else {
        alert('เกิดข้อผิดพลาดในการแก้ไขข้อมูล: ' + result.error);
      }
    } else {
      // เพิ่มข้อมูลใหม่
      const result = await createCustomer(formData);
      if (result.success) {
        alert('เพิ่มลูกค้าใหม่เรียบร้อยแล้ว');
      } else {
        alert('เกิดข้อผิดพลาดในการเพิ่มข้อมูล: ' + result.error);
      }
    }
    
    setShowForm(false);
    setEditingCustomer(null);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingCustomer(null);
  };

  // ฟังก์ชันจัดการการค้นหา
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchFilters(prev => ({ ...prev, [name]: value }));
  };

  // กรองข้อมูลลูกค้าตามเงื่อนไขการค้นหา
  const filteredCustomers = (customers || []).filter(customer => {
    const matchesName = !searchFilters.customerName || 
      (customer.customerName && customer.customerName.toLowerCase().includes(searchFilters.customerName.toLowerCase()));
    
    const matchesPhone = !searchFilters.phoneNumber || 
      (customer.phoneNumber && customer.phoneNumber.toLowerCase().includes(searchFilters.phoneNumber.toLowerCase()));
    
    const matchesContact = !searchFilters.contactPerson || 
      (customer.contactPerson && customer.contactPerson.toLowerCase().includes(searchFilters.contactPerson.toLowerCase()));
    
    const matchesCode = !searchFilters.customerCode || 
      (customer.customerCode && customer.customerCode.toLowerCase().includes(searchFilters.customerCode.toLowerCase()));
    
    return matchesName && matchesPhone && matchesContact && matchesCode;
  });

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>
          <i className="fas fa-users me-2"></i>
          จัดการข้อมูลลูกค้า
        </h3>
        <button className="btn btn-primary" onClick={handleAdd}>
          <i className="bi bi-plus"></i> เพิ่มลูกค้าใหม่
        </button>
      </div>

      {showForm && (
        <div className="card mb-4">
          <div className="card-header">
            <h5>{editingCustomer ? 'แก้ไขข้อมูลลูกค้า' : 'เพิ่มลูกค้าใหม่'}</h5>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">ชื่อลูกค้า</label>
                  <input
                    type="text"
                    className="form-control"
                    name="customerName"
                    value={formData.customerName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">เบอร์โทรศัพท์</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">ผู้ติดต่อ</label>
                  <input
                    type="text"
                    className="form-control"
                    name="contactPerson"
                    value={formData.contactPerson}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">รหัสลูกค้า</label>
                  <input
                    type="text"
                    className="form-control"
                    name="customerCode"
                    value={formData.customerCode}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              <div className="mb-3">
                <label className="form-label">ที่อยู่หลัก</label>
                <textarea
                  className="form-control"
                  name="mainAddress"
                  value={formData.mainAddress}
                  onChange={handleInputChange}
                  rows="3"
                ></textarea>
              </div>
              
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="form-label">เลขประจำตัวผู้เสียภาษี</label>
                  <input
                    type="text"
                    className="form-control"
                    name="taxId"
                    value={formData.taxId}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              <div className="mb-3">
                <label className="form-label">ที่อยู่จัดส่ง</label>
                <textarea
                  className="form-control"
                  name="deliveryAddress"
                  value={formData.deliveryAddress}
                  onChange={handleInputChange}
                  rows="2"
                ></textarea>
              </div>
              
              <div className="d-flex gap-2">
                <button type="submit" className="btn btn-success">
                  {editingCustomer ? 'บันทึกการแก้ไข' : 'เพิ่มลูกค้า'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                  ยกเลิก
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* การค้นหา */}
      <div className="card mb-4">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">การค้นหา</h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-3">
              <label className="form-label">ชื่อลูกค้า</label>
              <input
                type="text"
                className="form-control"
                name="customerName"
                value={searchFilters.customerName}
                onChange={handleSearchChange}
                placeholder="ค้นหาชื่อลูกค้า..."
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">เบอร์โทรศัพท์</label>
              <input
                type="text"
                className="form-control"
                name="phoneNumber"
                value={searchFilters.phoneNumber}
                onChange={handleSearchChange}
                placeholder="ค้นหาเบอร์โทรศัพท์..."
              />
            </div>
            <div className="col-md-2">
              <label className="form-label">ผู้ติดต่อ</label>
              <input
                type="text"
                className="form-control"
                name="contactPerson"
                value={searchFilters.contactPerson}
                onChange={handleSearchChange}
                placeholder="ค้นหาผู้ติดต่อ..."
              />
            </div>
            <div className="col-md-2">
              <label className="form-label">รหัสลูกค้า</label>
              <input
                type="text"
                className="form-control"
                name="customerCode"
                value={searchFilters.customerCode}
                onChange={handleSearchChange}
                placeholder="ค้นหารหัสลูกค้า..."
              />
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setSearchFilters({
                  customerName: '',
                  phoneNumber: '',
                  contactPerson: '',
                  customerCode: ''
                })}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header bg-light">
          <h5 className="mb-0">รายการลูกค้า ({filteredCustomers.length} รายการ)</h5>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th>ID</th>
              <th>รหัสลูกค้า</th>
              <th>ชื่อลูกค้า</th>
              <th>เบอร์โทรศัพท์</th>
              <th>ผู้ติดต่อ</th>
              <th>ที่อยู่หลัก</th>
              <th>เลขภาษี</th>
              <th>จัดการ</th>
            </tr>
          </thead>
          <tbody>
            {filteredCustomers.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  <i className="fas fa-users fa-3x text-muted mb-3"></i>
                  <p className="text-muted mb-0">
                    {(customers || []).length === 0 ? 'ยังไม่มีข้อมูลลูกค้า' : 'ไม่พบข้อมูลที่ตรงกับเงื่อนไขการค้นหา'}
                  </p>
                </td>
              </tr>
            ) : (
              filteredCustomers.map((customer) => (
                <tr key={customer.id}>
                  <td>{customer.id}</td>
                  <td>{customer.customerCode}</td>
                  <td>{customer.customerName}</td>
                  <td>{customer.phoneNumber}</td>
                  <td>{customer.contactPerson}</td>
                  <td>
                    <div style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {customer.mainAddress}
                    </div>
                  </td>
                  <td>{customer.taxId}</td>
                  <td>
                    <div className="d-flex gap-1">
                      <button 
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => handleEdit(customer)}
                        title="แก้ไข"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      <button 
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(customer.id)}
                        title="ลบ"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerPage;
